import { useIsCapturing } from '@/lib/recordings/use-is-capturing';
import { isDesktop } from '@/lib/platform';
import { useUIStore } from '@/stores/use-ui-store';
import { useUpdateScheduler } from './use-update-scheduler';

/**
 * Runs the background update check and routes the notification's action.
 *
 * Lives above the settings modal rather than inside it: the modal's open state
 * belongs to the UI store, so a component that can only set the active tab
 * cannot actually show anything. Mounting it here also means the schedule does
 * not depend on the modal being rendered.
 *
 * Renders nothing — the notification is imperative.
 */
export function UpdateNotifier() {
  const setSettingsOpen = useUIStore((s) => s.setSettingsOpen);
  const isRecording = useIsCapturing();

  useUpdateScheduler({
    enabled: isDesktop,
    isRecording,
    onOpen: () => setSettingsOpen(true, 'updates'),
  });

  return null;
}
